var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0037 20V11H9.50366V9.5H11.7537C12.1679 9.5 12.5037 9.83579 12.5037 10.25V19.25H21.8325L23.3325 13.25H14.0037V11.75H24.2931C24.7073 11.75 25.0431 12.0858 25.0431 12.5C25.0431 12.5613 25.0356 12.6224 25.0207 12.6819L23.1457 20.1819C23.0623 20.5158 22.7623 20.75 22.4181 20.75H11.7537C11.3395 20.75 11.0037 20.4142 11.0037 20ZM12.5037 25.25C11.6752 25.25 11.0037 24.5785 11.0037 23.75C11.0037 22.9215 11.6752 22.25 12.5037 22.25C13.3321 22.25 14.0037 22.9215 14.0037 23.75C14.0037 24.5785 13.3321 25.25 12.5037 25.25ZM21.5037 25.25C20.6752 25.25 20.0037 24.5785 20.0037 23.75C20.0037 22.9215 20.6752 22.25 21.5037 22.25C22.3321 22.25 23.0037 22.9215 23.0037 23.75C23.0037 24.5785 22.3321 25.25 21.5037 25.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3aebe894d86a8825c6488aac56847739.svg";
export { ForwardRef as ReactComponent };